<template>
  <div>
    <div class="body-wrapper">
      <div class="left-column">
        <div class="box">
          <div class="title-wrapper main-title">
            <b class="title">Informacije</b>
            <div class="actions">
              <i class="fas fa-pen" @click="openEditReminder()"></i>
              <i
                class="fas fa-trash"
                @click="showModal('ModalContentDeleteReminder')"
              ></i>
            </div>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="info-box">
            <div class="left-column" v-if="!loading">
              <div class="div-description single-info">
                <small class="label">Naziv</small>
                <h4 class="value">{{ reminder.title }}</h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Opis</small>
                <h4 class="value">
                  {{ reminder.description ? reminder.description : '/' }}
                </h4>
              </div>
              <div
                class="fullname single-info"
                v-if="reminder.startDate != reminder.nextInstance"
              >
                <small class="label">Datum početka</small>
                <h4 class="value">
                  {{ reminder.startDate | formatDateTimeNoSeconds }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Datum sledećeg izvršavanja</small>
                <h4 class="value">
                  {{ reminder.nextInstance | formatDateTimeNoSeconds }}
                </h4>
              </div>
              <div class="fullname single-info" v-if="reminder.humanReadable">
                <small class="label">Ponavljanje</small>
                <h4 class="value">
                  {{ reminder.humanReadable }}
                </h4>
              </div>
              <div class="fullname single-info" v-if="reminder.infrastructure">
                <small class="label">Infrastruktura</small>
                <h4 class="value">
                  {{ reminder.infrastructure.name }}
                </h4>
              </div>
              <div class="fullname single-info" v-if="reminder.contractor">
                <small class="label">Serviser</small>
                <h4 class="value">
                  {{ reminder.contractor.name }}
                </h4>
              </div>
              <div
                class="fullname single-info"
                v-if="reminder.contractorContact"
              >
                <small class="label">Kontakt servisera</small>
                <h4 class="value">
                  {{ reminder.contractorContact.name }} ({{
                    reminder.contractorContact.phone
                  }})
                </h4>
                <a
                  v-if="reminder.contractorContact.email"
                  class="column"
                  :href="'mailto: ' + reminder.contractorContact.email"
                  >{{ reminder.contractorContact.email }}</a
                >
              </div>
              <div class="fullname single-info">
                <small class="label">Datum kreiranja podsetnika</small>
                <h4 class="value">
                  {{ reminder.createdTs | formatDateTimeNoSeconds }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Obaveštenje putem emaila</small>
                <h4 class="value">
                  {{ reminder.notifyViaMail == '0' ? 'Ne' : 'Da' }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Kreirati tiket</small>
                <h4 class="value">
                  {{ reminder.createTicket == '0' ? 'Ne' : 'Da' }}
                </h4>
              </div>
              <div
                class="fullname single-info"
                v-if="reminder.createTicket == '1'"
              >
                <small class="label">Proslediti tiket serviseru</small>
                <h4 class="value">
                  {{ reminder.forwardToContractor == '0' ? 'Ne' : 'Da' }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-column">
        <div class="box transactions">
          <div class="title-wrapper">
            <b class="title">Izvršavanja</b>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="table" v-if="!loading">
            <div class="logs-table">
              <data-table
                :columns="table.tableColumns"
                :tableData="reminder.logs"
                :options="table.tableOptions"
                :hideDefaultSort="true"
                :slotNameReminderTicket="'ticketId'"
                :slotDateReminder="'dateFormatted'"
              ></data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { formatDateNoSecondsMixin } from '@/mixins/mixins.js';
import DataTable from '@/components/community/Table';

export default {
  name: 'CommunityReminderDetails',
  components: {
    DataTable
  },
  mixins: [formatDateNoSecondsMixin],
  data() {
    return {
      table: {
        tableColumns: ['dateFormatted', 'ticketId'],
        tableOptions: {
          filterable: false,
          sortable: [],
          headings: {
            dateFormatted: 'Datum',
            ticketId: 'Akcije'
          },
          texts: {
            count: '',
            noResults: 'Ne postoje izvršavanja'
          },
          perPage: 8
        }
      }
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', ['reminder'])
  },
  async created() {
    this.cardOpened();
    this.setTableBadge('fas fa-calendar-check');
    try {
      await this.getReminderById(this.$route.params.reminderId);
    } catch (error) {
      if (error.response.status == 404) {
        this.$router.push('/notFound');
      } else {
        console.log(error);
        this.showFailModal();
        this.back();
      }
    }
  },
  destroyed() {
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', ['setTableBadge']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['showModal', 'setContractor']),
    ...mapActions('table', ['getReminderById']),
    back() {
      this.$router.back();
    },
    openEditReminder() {
      this.showModal('ModalContentEditReminder');
    }
  }
};
</script>
<style lang="scss">
.logs-table {
  tr th:nth-child(2) {
    width: 1%;
    white-space: nowrap;
  }
}
</style>
<style lang="scss" scoped>
.actions {
  .fa-pen {
    margin-right: 16px;
  }
  .fa-trash {
    color: var(--danger-color);
  }
}
.header-contractor {
  margin-bottom: 40px;
  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}
.contractor-details {
  margin-left: auto;
}
.invoice-date {
  background: none !important;
  font-size: 0.8rem;
  font-weight: 800;
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
}

.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .btn {
    color: var(--primary-color);
    background: #e6e6e6;
    padding: 2px 5px;
    font-size: 0.9rem;
    float: right;
    margin-right: 14px;
    &:hover {
      background: rgb(210, 210, 210);
    }
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}

.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 2;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
        word-break: break-word;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 2;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;
      padding-left: 0 !important;
      li {
        font-size: 1rem;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        .index {
          width: 5%;
        }
        .name {
          width: 25%;
        }
      }

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
          .more {
            margin-right: 8px;
          }
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 100%;
          flex-direction: column;
          padding-left: 8px;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
          .row-desc {
            font-weight: bold;
          }
          .column {
            word-break: break-word;
          }
        }

        &.expanded-content {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}
.email-field {
  margin: 3px 0;
}
.email-subject {
  margin-bottom: 5px;
}

.main-title {
  display: flex;
  justify-content: space-between;
  i {
    cursor: pointer;
    color: var(--primary-color);
  }
}

.upload-area {
  margin-top: 5px;
  padding: 5px 0;

  .no-files {
    padding: 0 5px;
  }
  .uploaded {
    background-color: rgb(241, 241, 241);
    border-radius: 4px;
  }
  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding: 0 5px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 8px;
      margin-bottom: 2px;
    }

    .del--mod {
      margin-left: auto;

      cursor: pointer;
      color: red;
    }
  }
}
</style>
